<template>
    <div role="group">
        <label v-if="!nonshowlabel" for="input-live">
            ขนาดพัสดุ (เซนติเมตร)
            <small class="text-danger">*</small>
        </label>
        <div class="row">
            <div class="col boxs">
                <input
                    ref="focusWidth"
                    type="number"
                    min="1"
                    placeholder="กว้าง"
                    class="form-control"
                    :disabled="favoriteDimension"
                    v-model="dimension.width"
                    @keyup="checkDimension()"
                    @blur="checkDimension()"
                    :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                    :class="{ 'is-invalid': $v.dimension.width.$error || validateDimension.checkDimension.status || openBorderError}"
                />
                <div
                    v-if="!$v.dimension.width.required"
                    class="invalid-feedback"
                >
                    กรุณากรอกขนาดความกว้างของพัสดุ
                </div>
                <div
                    v-if="!$v.dimension.width.dimensionWidth"
                    class="invalid-feedback"
                >
                    กรุณากรอกขนาดความกว้างของพัสดุไม่เกิน {{maxSize.width}} ซม.
                </div>
            </div>
            <div class="col boxs">
                <input
                    type="number"
                    min="1"
                    placeholder="ยาว"
                    class="form-control"
                    :disabled="favoriteDimension"
                    v-model="dimension.length"
                    @keyup="checkDimension()"
                    @blur="checkDimension()"
                    :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                    :class="{ 'is-invalid': $v.dimension.length.$error || validateDimension.checkDimension.status || openBorderError}"
                />
                <div
                    v-if="!$v.dimension.length.required"
                    class="invalid-feedback"
                >
                    กรุณากรอกขนาดความยาวของพัสดุ
                </div>
                <div
                    v-if="!$v.dimension.length.dimensionLength"
                    class="invalid-feedback"
                >
                    กรุณากรอกขนาดความยาวของพัสดุไม่เกิน {{maxSize.length}} ซม.
                </div>
            </div>
            <div class="col">
                <input
                    type="number"
                    min="1"
                    placeholder="สูง"
                    class="form-control"
                    :disabled="favoriteDimension"
                    v-model="dimension.height"
                    @keyup="checkDimension()"
                    @blur="checkDimension()"
                    :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                    :class="{ 'is-invalid': $v.dimension.height.$error || validateDimension.checkDimension.status || openBorderError}"
                />
                <div
                    v-if="!$v.dimension.height.required"
                    class="invalid-feedback"
                >
                    กรุณากรอกขนาดความสูงของพัสดุ
                </div>
                <div
                    v-if="!$v.dimension.height.dimensionHeight"
                    class="invalid-feedback"
                >
                    กรุณากรอกขนาดความสูงของพัสดุไม่เกิน {{maxSize.height}} ซม.
                </div>
            </div>
            <div class="col-1 d-flex align-items-center pl-0" v-if="showLock">
                <span @click="$emit('lockDimensionParcel')">
                    <Icon 
                        :icon="(favoriteDimension) ? 'mdi-lock' : 'mdi-lock-open-variant'" 
                        class="cursor-pointer lockDimension"
                    />
                </span>
            </div>
            <small 
                v-if="validateDimension.checkDimension.status" 
                class="text-danger px-3"
            >{{validateDimension.checkDimension.msg}} </small>
        </div>
    </div>
</template>

<script>
import { checkDimensionRules , checkDimensionWidth , checkDimensionLength , checkDimensionHeight } from "@/plugins/dimensionParcel.js"
import courierRules from "@/constants/CourierRules";
import {
  required
} from "vuelidate/lib/validators"

export default {
    props:{
        dimension: Object,
        courierCode: String,
        favoriteDimension: Boolean,
        showLock: {
            type: Boolean,
            default: true
        },
        nonshowlabel: {
            type: Boolean,
            default: false
        },
        openBorderError: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            validateDimension:{
                checkDimension:{
                    status:false,
                    msg:""
                }
            }
        }
    },
    validations(){
        return this.rulesDimension     
    },
    methods:{
        checkDimension(){
            const { status , msg } = checkDimensionRules( this.courierCode , this.dimension );
            this.validateDimension.checkDimension.status = status
            this.validateDimension.checkDimension.msg = msg
        },
    },
    computed:{
        maxSize(){
            return {
                width: courierRules[this.courierCode].maxSize.width,
                length: courierRules[this.courierCode].maxSize.length,
                height: courierRules[this.courierCode].maxSize.height,
            }
        },
        rulesDimension(){
            return {
                dimension:{
                    width: { required, dimensionWidth: checkDimensionWidth(this.courierCode) },
                    length: { required, dimensionLength: checkDimensionLength(this.courierCode) },
                    height: { required, dimensionHeight: checkDimensionHeight(this.courierCode) },
                }
            }
        }
    }
}
</script>